import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import {FormatService} from '../../../../services/format.service';
import {DocumentSummaryItem} from '../../../../model/document-summary-item';
import {LocalizedText} from '../../../../model/localized-text';
import { TranslatePipe } from '@ngx-translate/core';
import { IbanFormatterPipe } from '../../../../pipes/iban-formatter.pipe';

interface PaymentCalculationTotal {
  unemploymentGrossAmount: number;
  unemploymentHoldingTax: number;
  unemploymentNetAmount: number;
  additionalCompensationGrossAmount: number;
  additionalCompensationHoldingTax: number;
  additionalCompensationNetAmount: number;
}

@Component({
    selector: 'myabvv-allowances-detail-calculation',
    standalone: true,
    templateUrl: './allowances-detail-calculation.component.html',
    styleUrls: ['./allowances-detail-calculation.component.css'],
    imports: [TranslatePipe, IbanFormatterPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowancesDetailCalculationComponent implements OnInit {
  private formatService = inject(FormatService);


  totalCalculation: PaymentCalculationTotal = {
    unemploymentGrossAmount: 0,
    unemploymentHoldingTax: 0,
    unemploymentNetAmount: 0,
    additionalCompensationGrossAmount: 0,
    additionalCompensationHoldingTax: 0,
    additionalCompensationNetAmount: 0,
  };

  @Input() summaryItem: DocumentSummaryItem;

  ngOnInit(): void {
    this.computeTotals();
  }

  getTranslatedData(array: LocalizedText[] | null | undefined): string {
    return this.formatService.getTranslatedData(array);
  }

  getCurrency(currency: string): string {
    return this.formatService.formatCurrency(currency);
  }

  getFormattedNumber(result: number | string): string {
    return this.formatService.formatNumber(result);
  }

  calculateTotal(amount: string, number: number): number {
    const amountNum = parseFloat(amount.replace(',', '.'));

    if (isNaN(amountNum)) {
      return 0;
    }

    return amountNum * number;
  }

  computeTotals(): void {
    for (const calc of this.summaryItem.paymentCalculations || []) {
      const ui = calc.unemploymentInfo;
      const ac = calc.additionalCompensation;

      if (ui) {
        this.totalCalculation.unemploymentGrossAmount += parseFloat(ui.unemploymentGrossAmount || '0');
        this.totalCalculation.unemploymentHoldingTax += parseFloat(ui.unemploymentHoldingTax || '0');
        this.totalCalculation.unemploymentNetAmount += parseFloat(ui.unemploymentNetAmount || '0');
      }

      if (ac) {
        this.totalCalculation.additionalCompensationGrossAmount += parseFloat(ac.additionalCompensationGrossAmount || '0');
        this.totalCalculation.additionalCompensationHoldingTax += parseFloat(ac.additionalCompensationHoldingTax || '0');
        this.totalCalculation.additionalCompensationNetAmount += parseFloat(ac.additionalCompensationNetAmount || '0');
      }
    }
  }
}
